<template>
    <div>
        <!-- mensajes de confirmacion -->
        <mensajeSistema></mensajeSistema>
        <v-dialog v-model="estadoComp" persistent scrollable max-width="90%">
            <v-card>

                <v-card-title class="modal_title py-5 mb-2">
                    <v-row class="d-flex justify-space-between">
                        Listado de estudiantes
                        <!-- <v-chip :color="datosProgDocente.color_nivel"> -->
                        <v-chip color="green">
                            <span class="px-0 white--text font-weight-black">
                                Evaluación: {{ evaluacion.nombre_evaluacion }}
                            </span>
                        </v-chip>
                        <v-btn fab dark x-small class="btn_style3" @click="$emit('close')"><v-icon
                                dark>fa-times</v-icon></v-btn>
                    </v-row>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text>
                    <v-row>
                        <v-col cols="12" class="d-flex justify-start">
                            <p class="body-1 mb-0 black--text">
                                <span class="font-weight-black">Nivel: </span>
                                {{ evaluacion.desc_nivel }}
                                <span class="font-weight-black">Grado: </span>
                                {{ evaluacion.desc_grado }}
                                <span class="font-weight-black">Sección: </span>
                                {{ evaluacion.nombre_seccion }}
                            </p>
                        </v-col>
                    </v-row>

                    <v-data-table :headers="headers" :items="data" :search="search" :sort-by="['nombre_template']"
                        :sort-desc="[false]" class="elevation-1 black--text" fixed-header>

                        <template v-slot:[`item.action_nota`]="{ item }">
                            <v-tooltip bottom color="#1b1b1b">
                                <template v-slot:activator="{ on }">
                                    <v-chip
                                        v-if="item.tipo_calificacion == 'L' && item.id_estado_evaluacion == 5 || item.id_estado_evaluacion == 4"
                                        id_estado_evaluacion color="green" v-on="on" class="texto_white"
                                        label>{{ item.literal }}</v-chip>

                                    <v-chip v-else-if="item.tipo_calificacion == 'N' && item.id_estado_evaluacion == 5"
                                        color="green" v-on="on" class="texto_white" label>{{ item.nota_alumno }}
                                        {{ item.tipo_calificacion }}</v-chip>
                                    <v-chip v-else color="green" v-on="on" class="texto_white" label> - </v-chip>
                                </template>
                                <span>CALIFICACIÓN DEL ESTUDIANTE</span>
                            </v-tooltip>
                        </template>

                        <template v-slot:[`item.id_estado_evaluacion`]="{ item }">
                            <v-chip small dark class="font-weight-black" :color="item.color_estado">
                                {{ item.estado_evaluacion }}
                            </v-chip>

                        </template>


                        <template v-slot:[`item.action_ver`]="{ item }">
                            <v-tooltip bottom color="#1b1b1b">
                                <template v-slot:activator="{ on }">
                                    <v-btn v-if="componenteEvento.editar_submodulo" v-on="on" class="btn_ver px-0 mx-0"
                                        fab x-small @click="verItem(item)">
                                        <v-icon>fa-eye</v-icon>
                                    </v-btn>
                                </template>
                                <span>VER EVALUACIÓN</span>
                            </v-tooltip>
                        </template>


                        <template v-slot:[`item.action_calificar`]="{ item }">
                            <v-tooltip bottom color="#1b1b1b">
                                <template v-slot:activator="{ on }">
                                    <v-btn v-if="componenteEvento.editar_submodulo" v-on="on"
                                        :disabled="item.estado_evaluacion == 'Evaluada'" class="btn_agregar px-0 mx-0"
                                        fab x-small @click="QualifyItem(item)">
                                        <v-icon>fas fa-list-alt</v-icon>
                                    </v-btn>
                                </template>
                                <span>CALIFICAR EVALUACIÓN</span>
                            </v-tooltip>
                        </template>

                    </v-data-table>
                </v-card-text>

                <span v-if="test">
                    Datos: <code>{{ data }}</code> <br>
                </span>
            </v-card>

        </v-dialog>

        <!-- fin consulta -->

        <!-- END de modal para visualizar Imagen-->
        <component :is="compName" :estadoComp="estadoComponente" :parametros="parametroComp" @close="CloseComp">
        </component>

    </div>
</template>

<script>

import axios, { API_URL } from "@/helpers/axios";
import { mapMutations, mapGetters, mapActions } from 'vuex';
import VisorEvaluacionComp from '@/views/Evaluacion/VisorEvaluacion/visorEvaluacion'
export default {
    name: 'AlumnoEvaluacionVirtual',
    components: {
        VisorEvaluacionComp
    },

    props: {
        parametros: {
            type: Object
        },
        estadoComp: {
            type: Boolean
        },
    },


    data: () => ({
        //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
        rutaservidor: API_URL,
        paramComponente: { "id_modulo": 7, 'id_submodulo': 97 }, //sud_modulo y modulo
        datoLogin: sessionStorage, // variables de sesion del usuario
        test: false,
        // componente General
        compName: null,
        estadoComponente: false,
        parametroComp: {},
        formTitle: '',
        ////////////////////////////////////////////////////////

        // evento: 'agregar',
        search: '',
        data: [],
        filter: {},
        evaluacion: {},
        id_docente: null,

        headers: [
            { text: 'N.° DE DOCUMENTO DE IDENTIDAD', value: 'numdoc_alumno', class: 'secondary black--text' },
            { text: 'APELLIDOS', value: 'alumno_apellido', align: 'center', class: 'secondary black--text' },
            { text: 'NOMBRES', value: 'alumno_nombre', align: 'center', class: 'secondary black--text' },
            { text: 'CALIFICACIÓN', value: 'action_nota', class: 'secondary black--text' },
            { text: 'ESTADO', value: 'id_estado_evaluacion', align: 'center', class: 'secondary black--text' },
            { text: 'VISUALIZAR EVALUACIÓN', value: 'action_ver', sortable: false, align: 'center', class: 'secondary black--text px-0 mx-0', width: '80' },
            { text: 'CALIFICAR EVALUACIÓN', value: 'action_calificar', sortable: false, align: 'center', class: 'secondary black--text px-0 mx-0', width: '80' },

        ],

    }),

    //computadas
    computed: {
        ...mapGetters('login', ['componenteEvento'])

    },

    mounted() {
        this.LoadMain()
    },

    created() {
        // this.actualizarParamentro()
    },

    watch: {
        // cada vez que la pregunta cambie, esta función será ejecutada
        estadoComp() {

            if (this.estadoComp) {
                this.LoadMain()
            } else {
                //this.parametros = {}
                this.LimpiarForm()

            }
        }
    },



    methods: {
        //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA //////////////////////
        // -- Validar accesos por perfil ------------
        ...mapActions('login', ['parametroComponente']),
        actualizarParamentro() {
            this.parametroComponente(this.paramComponente)
        },

        //  ------- MENSAJE DE SISTEMA  --------
        ...mapMutations('mensajeSis', ['setEnviarMens']),
        ////////////////////////////////////////////////////////

        //-- cargar Parametros de inicio del componente --
        async LoadMain() {

            this.LimpiarForm()
            this.evaluacion = this.parametros.items
            this.filter.id_evaluacion = this.parametros.items.id
            this.getEvaluacionAlumnos(this.filter)

        },


        //-------mostrar registros------------
        async getEvaluacionAlumnos(filter) {
            try {
                let response = await axios.post(`/evaluacion/alumnos/view/`, { filter })
                this.data = response.data

                if (this.data.length == 0) {
                    this.setEnviarMens({ tipo: "W", mensaje: `No se encontrarón registros`, tiempo: null })
                }

            } catch (error) {
                console.error(error);
                this.setEnviarMens({ tipo: "E", mensaje: `Ha ocurrio un error inesperado`, tiempo: null });
            }

        },


        ///////////////////////////////////////////////////
        //-- Componente de Alumnos    -------- ///



        verItem(items) {

            let params = {
                id_evaluacion: items.id_evaluacion,
                id_colegio: items.id_colegio,
                id_profesor: items.id_profesor,
                id_alumno: items.id_alumno
            }

            let data = { evento: "qualifyAlumno", items: params }
            this.parametroComp = data
            this.compName = "VisorEvaluacionComp"

            setTimeout(() => {
                this.estadoComponente = true
            }, 500);


        },

        QualifyItem(items) {

            let params = {
                id: items.id,
                id_evaluacion: items.id_evaluacion,
                id_colegio: items.id_colegio,
                id_profesor: items.id_profesor,
                id_alumno: items.id_alumno,
                tipo_calificacion: items.tipo_calificacion
            }

            let data = { evento: "qualify", items: params }

            this.parametroComp = data
            this.compName = "VisorEvaluacionComp"
            this.estadoComponente = true

        },





        /*******cerrar modal y blanquear arreglos */
        CloseComp() {
            this.parametroComp = {}
            this.estadoComponente = false
            this.LoadMain()
        },


        LimpiarForm() {

            this.filter = {
                id_colegio: this.datoLogin.id_colegio,
                id_ano_lectivo: this.datoLogin.id_ano_lectivo,
                id_evaluacion: -1

            }

            this.evaluacion = {
                desc_nivel: "",
                desc_grado: "",
                nombre_seccion: "",
                nombre_evaluacion: ""
            }

            this.paramComponente = {}

        },


    },

}

</script>

<style scoped>
.texto_white {
    font-size: 14px;
    font-weight: bold;
    color: #fff !important;

}
</style>